module.exports = __webpack_public_path__ + "img/blue_134.38fe9427.png";